import React from 'react';

import {Header, Breadcrumb, Segment,Container, Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio,Image, Table, List, Popup, Icon} from 'semantic-ui-react';
import { Link } from "react-router-dom";


const Homecat = ({datos, onChange, ajaxCallInProgress, cursoCombo, strings, errors, onSave,  onHandleFileImagen, imgBanner, onSaveImage, homeImagenes, onBorrar}) => {
  
    return (
      <Container>
        <Dimmer.Dimmable   dimmed={ajaxCallInProgress>0?true:false}>
        <Segment basic>
				<Header  as='h2'   dividing>             
					<Header.Content>{strings?strings["home"]:""}</Header.Content>
				</Header>
			 
			<Grid container>
                <Grid.Row>
                    <Grid.Column >
                        <Form  >          
                            <Form.Field  required  error={errors.descripcion}>            
                              <label  >{strings?strings["QualityAcademicsDesc"]:""}</label>
                              <TextArea 
                                    placeholder={strings?strings["QualityAcademicsDesc"]:""} 
                                    name="descripcion"
                                    onChange={onChange}
                                    value={datos.descripcion}
                                    />
                            </Form.Field>
        
                              <Form.Field  required  error={errors.descripcionen}>            
                              <label  >{strings?strings["QualityAcademicsDescIngles"]:""}</label>
                              <TextArea 
                                    placeholder={strings?strings["QualityAcademicsDescIngles"]:""} 
                                    name="descripcionen"
                                    onChange={onChange}
                                    value={datos.descripcionen}
                                    />
                            </Form.Field>
        
                            <Form.Field  required  error={errors.descripcionpr}>            
                              <label  >{strings?strings["QualityAcademicsDescIngles"]:""}</label>
                              <TextArea 
                                    placeholder={strings?strings["QualityAcademicsDescIngles"]:""} 
                                    name="descripcionpr"
                                    onChange={onChange}
                                    value={datos.descripcionpr}
                                    />
                            </Form.Field>
        
                            <Form.Field  required  error={errors.idCursoTop}>
                              <label  >{strings?strings["idCursoTop"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idCursoTop"]:""} 
                                    name="idCursoTop"
									 fluid 
                                    search 
                                    selection
                                    
                                    onChange={onChange}
                                    value={datos.idCursoTop}
                                    options={cursoCombo}/>
                            </Form.Field>
        
        
                        <Form.Field  required  error={errors.idCursoMedio}>
                              <label  >{strings?strings["idCursoMedio"]:""}</label>
                              <Dropdown 
                                    placeholder={strings?strings["idCursoMedio"]:""} 
                                    name="idCursoMedio"
									 fluid 
                                    search 
                                    selection
                                    
                                    onChange={onChange}
                                    value={datos.idCursoMedio}
                                    options={cursoCombo}/>
                            </Form.Field>
                      
                                                                        
                            <Divider hidden/>
							  <Grid centered>
                            <Button.Group  >
                                <Link to="/tags">
                                    <Button  
										 >{strings?strings["regresar"]:""}</Button>
                                </Link>
								  
                                <Button.Or text=" "></Button.Or>
								  
								  
                                <Button  color="black"
                                    onClick={onSave}>{strings?strings["guardar"]:""}
								 </Button>
								  
                              </Button.Group>
                            </Grid>
                           
                        </Form>
                    </Grid.Column>
                </Grid.Row>
                
            
            </Grid>
        
        
        <Header  as='h2'   dividing>             
					<Header.Content>{strings?strings["agregarImagen"]:""}</Header.Content>
				</Header>
        
        
        <Grid container>
                <Grid.Row>
                    <Grid.Column >
        
        
                            <Form.Field  >
                                <label>{strings?strings["imagenBanner"]:""} </label>
                                <Input placeholder='imagenBanner'
                                onChange={(a, b)=>onHandleFileImagen(a,b,1)}
                                name="imagenBanner"
                                type='file'

                            />
                            <br/>        
        
                            {imgBanner.imagePreviewUrl?
                                    <Segment basic>
                                        <Image src={imgBanner.imagePreviewUrl} size="big" fluid />
                                    </Segment>
                                    
                                :
                                    "sin imagen"
        
                            }
        
                            </Form.Field>
                            
                            
                            
                             <Divider hidden/>
							  <Grid centered>
                                <Button.Group  >
                               
                                <Button  color="black"
                                    onClick={onSaveImage}>{strings?strings["add"]:""}
								 </Button>
                              </Button.Group>
                            </Grid>
                </Grid.Column>
            </Grid.Row>
            {homeImagenes!=null?                                       
            <Grid.Row>
                    <Grid.Column >
                
                    <Table  celled >
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>{strings?strings["imagen"]:""}</Table.HeaderCell>
                        <Table.HeaderCell textAlign="center">{strings?strings["accion"]:""}</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>
                                    
                    {homeImagenes.map(imagen => (
                     
                     <Table.Row>
                        <Table.Cell><Image src={"/info/resource/?nombre="+imagen.ruta} size='small'  /></Table.Cell>
                            <Table.Cell textAlign="center">
                            <List horizontal>

                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onBorrar(imagen.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                            
                            </List>
                        </Table.Cell>
                    </Table.Row>
                            
                     ))} 
            
                    </Table.Body>
                  </Table>
                    
            
             </Grid.Column>
            </Grid.Row>
            :                        
             
            <></>
             
            }
                                    
        </Grid>
        
         <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big'  content={strings?strings["Procesando"]:""}/>
          </Dimmer>
        
        </Segment>
        </Dimmer.Dimmable>
        </Container>
);
}
 

export default Homecat